/**
 * Tema düğmesi — sistem → açık → koyu → sistem.
 *
 * Yönetim panelindeki düğmenin aynısı; veli ve kasa da aynı davranışı
 * paylaşsın diye buraya taşındı.
 *
 * İkon ŞU ANKİ durumu gösterir, sıradakini değil: ikon bir vaat değil, bir
 * okumadır. Sıradakini göstermek, "güneşe basınca neden koyu oldu" sorusunu
 * doğurur.
 */
import { useSyncExternalStore } from "react";
import { IkonButon } from "./temel.js";
import { IkonAy, IkonEkran, IkonGunes, type IkonBileseni } from "./ikonlar.js";
import {
  TEMA_METNI,
  sonrakiTema,
  temaAbone,
  temaAyarla,
  temaOku,
  type Tema,
} from "../tema.js";

const IKON: Record<Tema, IkonBileseni> = {
  sistem: IkonEkran,
  acik: IkonGunes,
  koyu: IkonAy,
};

/** Seçili temayı okuyan abonelik — düğme dışında da kullanılabilir. */
export function useTema(): Tema {
  return useSyncExternalStore(temaAbone, temaOku, temaOku);
}

export function TemaDugmesi({
  boyut = 16,
  className,
}: {
  boyut?: number;
  className?: string;
}) {
  const tema = useTema();
  const Ikon = IKON[tema];
  return (
    <IkonButon
      etiket={`${TEMA_METNI[tema]} — değiştirmek için tıklayın`}
      onClick={() => temaAyarla(sonrakiTema(tema))}
      className={className}
    >
      <Ikon boyut={boyut} />
    </IkonButon>
  );
}
